import { connect } from "react-redux";
import VizMenu from "../components/VizMenu";
import { sceneSlice } from "../../store/sceneSlice";
import { sessionSlice } from "../../store/sessionSlice";

const mapStateToProps = (state) => {
  return {
    scale: state.scene.renderScale,
    pdb: state.scene.pdb,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetScale: (scale) => {
      dispatch(sceneSlice.actions.emitMoleculeScaleSet({ renderScale: scale }));
    },
    onSetAtomRadiusFactors: (applyVDW) => {
      dispatch(sceneSlice.actions.emitSetAtomRadiusFactors({ applyVDW }));
    },
    onSetAtomColors: (applyColor) => {
      dispatch(sceneSlice.actions.emitSetAtomColors({ applyColor }));
    },
    onSetStickRadius: (applyRadius) => {
      dispatch(sceneSlice.actions.emitSetStickRadius({ applyRadius }));
    },
    onMolRotationSetByValue: (newMolRotations) => {
      console.log("origin 5 (viz)")
      dispatch(sessionSlice.actions.emitSetMolRotationByValue({ newMolRotations }));
    },
    onMolRotationChange: (newMolRotations) => {
      console.log("origin 5 (viz) for rotation change")
      dispatch(sessionSlice.actions.emitSetMolRotationChange({ newMolRotations }));
    },
  };
};

export const VizMenuContainer = connect(mapStateToProps, mapDispatchToProps)(VizMenu);
